import { render, staticRenderFns } from "./Sales_Item.vue?vue&type=template&id=3b718654&scoped=true&"
import script from "./Sales_Item.vue?vue&type=script&lang=js&"
export * from "./Sales_Item.vue?vue&type=script&lang=js&"
import style0 from "./Sales_Item.vue?vue&type=style&index=0&id=3b718654&scoped=true&lang=css&"
import style1 from "./Sales_Item.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b718654",
  null
  
)

export default component.exports